import { EmberTheme } from "../.internal/themes/EmberTheme";
export default EmberTheme;
